// The booker renders into the host page's DOM, so ids need a prefix that
// won't collide with the embedding site's own ids.
export const STEP_ID_PREFIX = "wa-booker-step-";

/**
 * Scroll to the first of `stepIds` that is rendered and still incomplete,
 * falling back to the first one rendered at all.
 */
export const scrollToStep = (stepIds: string[]) => {
  const elements = stepIds
    .map(id => document.getElementById(`${STEP_ID_PREFIX}${id}`))
    .filter((el): el is HTMLElement => !!el);
  const target =
    elements.find(el => el.dataset.stepComplete === "false") ?? elements[0];
  target?.scrollIntoView({ behavior: "smooth", block: "start" });
};
